import { useUserAccount } from '@/api/user';
import { GenericError } from '@/models/generic-error';
import { ReferralVoucher } from '@/models/referral-voucher';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ReferralVouchersQueryKeys } from '../../queryKeys';
import { UseReferralVoucherMainQueryKey } from './props';
import { fetchReferralVoucherMain } from './service';

export function useReferralVoucherMain() {
  const { user } = useUserAccount();
  const queryKey: UseReferralVoucherMainQueryKey = [
    ReferralVouchersQueryKeys.Main,
  ];

  const { data, isPending, error, refetch, fetchStatus } = useQuery<
    ReferralVoucher,
    AxiosError<GenericError>,
    ReferralVoucher,
    UseReferralVoucherMainQueryKey
  >({
    queryKey,
    queryFn: fetchReferralVoucherMain,
    staleTime: 5 * 1000,
    enabled: !!user,
  });

  return {
    error,
    refetch,
    isLoading: isPending && fetchStatus !== 'idle',
    referralVoucher: data,
  };
}
